// extracted by mini-css-extract-plugin
module.exports = {"content":"TradingDashboard_content_HsWgY","aside":"TradingDashboard_aside_dVaD3","infoDialogText":"TradingDashboard_infoDialogText_1BcfD"};